import React, { useState } from 'react';

/** 팀 로고 — 이미지 로드 실패 시 첫 글자 배지 표시 */
const TeamLogo = ({ url, name, className = 'sp_team_logo' }) => {
  const [failed, setFailed] = useState(false);

  if (!url || failed) {
    if (!name) return null;
    const initial = (name || '?').charAt(0).toUpperCase();
    return (
      <span className={`sp_logo_badge ${className}`} title={name}>
        {initial}
      </span>
    );
  }

  return (
    <img
      src={url}
      alt=""
      className={className}
      onError={() => setFailed(true)}
    />
  );
};

export default TeamLogo;
